export function displayHost(hostname: string): string {
    return hostname.toLowerCase().replace(/^(?:www|m)\./u, "");
}
